import { Fragment, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutMain from "../../layouts/LayoutMain";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import SectionTitleWithText from "../../components/section-title/SectionTitleWithText";
import BannerAbout from "../../wrappers/banner/BannerAbout";
import TextGridOne from "../../wrappers/text-grid/TextGridOne";
import FunFactOne from "../../wrappers/fun-fact/FunFactOne";
import TeamMemberOne from "../../wrappers/team-member/TeamMemberOne";
import BrandLogoSliderOne from "../../wrappers/brand-logo/BrandLogoSliderOne";
import { useDispatch } from "react-redux";
import { fetchWebsiteSections } from "../../store/slices/app-slice";
import VerticalTimeline from "../../components/about/VerticalTimeline";
import SectionTitleMain from "../../components/section-title/SectionTitleMain";
import OurCoffeeBlock from "../../components/about/OurCoffeeBlock";
import OurShopBlock from "../../components/about/OurShopBlock";
import OurAchievementBlock from "../../components/about/OurAchievementBlock";
import TeamMemberMain from "../../wrappers/team-member/TeamMemberMain";
import OurSustainabilityBlock from "../../components/about/OurSustainabilityBlock";
import { useTranslation } from "react-i18next";

const About = () => {
    let { pathname, hash } = useLocation();
    const {t} = useTranslation();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchWebsiteSections());
    }, [dispatch]);

    useEffect(() => {
        // Use the CSS selector to find the element
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                // Scroll to the element
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [hash]);

    return (
        <Fragment>
            <SEO
                titleTemplate={t("about__seo_title")}
                description={t("about__seo_desc")}
            />
            <LayoutMain headerTop="visible">
                {/* breadcrumb */}
                <Breadcrumb
                    pages={[
                        { label: t("home__breadcrumb"), path: process.env.PUBLIC_URL + "/" },
                        {
                            label: t("about__breadcrumb"),
                            path: process.env.PUBLIC_URL + pathname,
                        },
                    ]}
                />

                {/* section title with text */}
                <SectionTitleWithText
                    spaceTopClass="pt-40"
                    spaceBottomClass="pb-95"
                    title={t("about__page_title")}
                    subtitle={t("about__page_subtitle")}
                    desc={t("about__page_desc")}
                />

                <div id="our-story">
                    {/* section title with text */}
                    <SectionTitleMain
                        spaceBottomClass="pb-45"
                        titleText={t("about__our_story")}
                    />

                    <div className="pb-100">
                        <VerticalTimeline />
                    </div>
                </div>

                {/* banner */}
                <BannerAbout spaceBottomClass="pb-70" />

                {/* text grid */}
                {/* <TextGridOne spaceBottomClass="pb-70" /> */}

                <div id="our-coffee">
                    {/* section title with text */}
                    <SectionTitleMain
                        spaceTopClass="pt-100"
                        spaceBottomClass="pb-45"
                        titleText={t("about__our_coffee")}
                    />

                    <div className="pb-100">
                        <OurCoffeeBlock />
                    </div>
                </div>

                <div id="our-shops">
                    {/* section title with text */}
                    <SectionTitleMain
                        spaceTopClass="pt-100"
                        spaceBottomClass="pb-45"
                        titleText={t("about__our_shops")}
                    />

                    <div className="pb-100">
                        <OurShopBlock />
                    </div>
                </div>

                <div id="our-achievements">
                    {/* section title with text */}
                    <SectionTitleMain
                        spaceTopClass="pt-100"
                        spaceBottomClass="pb-45"
                        titleText={t("about__our_achievements")}
                    />

                    <div className="pb-100">
                        <TeamMemberMain />
                        <OurAchievementBlock />
                    </div>
                </div>

                <div id="our-sustainability-practices">
                    {/* section title with text */}
                    <SectionTitleMain
                        spaceTopClass="pt-100"
                        spaceBottomClass="pb-45"
                        titleText={t("about__our_sustainable_practice")}
                    />

                    <div className="pb-100">
                        <OurSustainabilityBlock />
                    </div>
                </div>
            </LayoutMain>
        </Fragment>
    );
};

export default About;
